import type { BrandsWebsiteData, HTTPFunctions } from '../types';

const brands = ({ get, post }: HTTPFunctions) => ({
  getBrandWebsite: (state: string) => get<BrandsWebsiteData>(`/brands/state/${state}/`),
  setBrandWebsite: (website: string) => post<BrandsWebsiteData>('/brands/', { website_url: website }),
});

export default brands;
